import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@store/types';

import type { EligibilityChecksState } from './slice';

const selectEligibilityChecksState = (state: RootState): EligibilityChecksState | undefined =>
  state.eligibilityChecks;

export const selectWarningDismissed = createSelector(
  [selectEligibilityChecksState],
  state => state?.warningDismissed ?? false,
);

